import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Input,
    Typography,
    useMediaQuery,
    Grid
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import IOSSwitchComponent from '../switch/iso-style-switch';
import { DisabledByDefault } from '@mui/icons-material';
import useServices from '../../hooks/useServices';
import { Col, Form, Row } from 'react-bootstrap';

const AddWifiUserModel = ({reLogAccount, type="staff",openModel,handleSubmitAddWifiUser=()=>{},setIsModelOpen,departmentList=[],facultyList=[],onChangeFacultyList=()=>{} }) => {
    const [open, setOpen] = useState(false);
     const [userDetails, setUserDetails] = useState([]);
       // State to manage editable fields
    const [isEditing, setIsEditing] = useState([]);
    const [services] = useServices();
    const [autoGeneratedPassword, setAutogeneratedPassword] = useState("");
    


    

    useEffect(() => {
        setOpen(openModel);
       // console.log(services);
    }, [openModel]);


    const handleClose = () => {
        setOpen(false);
        setIsModelOpen(false);
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if the screen size is small


    const [userDetailsApplyEmail,setUserDetailsApplyEmail] = useState({
        initials: '',
        fname: '',
        lname: '',
        nic:'',
        mobile:'',
        department:0,
        faculty:0,
        terminateDate: null,
        terminateStartDate:null,
        wifiKey:'',
    });
    
    const [userDetailsRequestEmail,setUserDetailsRequestEmail] = useState({
        emailAddress: '',
    })
    
         const [validated, setValidated] = useState(false);
           const [errors, setErrors] = useState({
                initials: '',
                fname: '',
                lname: '',
                nic:'',
                mobile:'',
                department:'',
                faculty:'',
                terminateDate: '',
                terminateStartDate:null,
                wifiKey:'',
            });
    
      const [errorsReEmail, setErrorsReEmail] = useState({
        emailAddress: '',
      });
    
    
        const onSubmitActionApplyEmail = (event) => {
           
            event.preventDefault();
            if (validateForm()) {
                const submittedData = {
                            "initials": userDetailsApplyEmail.initials,
                            "lName": userDetailsApplyEmail.lname,
                            "nic": userDetailsApplyEmail.nic,
                            "mobile": userDetailsApplyEmail.mobile,
                            "department": userDetailsApplyEmail.department,
                            "faculty": userDetailsApplyEmail.faculty,
                            "terminateEndDate": userDetailsApplyEmail.terminateDate,
                            "terminateStartDate": userDetailsApplyEmail.terminateStartDate,
                            "wifiKey": userDetailsApplyEmail.wifiKey
                        };
                console.log(submittedData,"submited");
                handleSubmitAddWifiUser(submittedData);
            setValidated(true);
            } else {
            setValidated(false);
            }
            
        }

function generateWifiPassword(length = 6) {
  if (length < 4) {
    throw new Error("Password length must be at least 4 characters.");
  }

  const upper = "ABCDEFGHJKMNOPQRSTUVW";
  const lower = "abcdefghjkmnopqrstuvw";
  const digits = "0123456789";
  const special = "@$";

  // Ensure at least one of each required character
  const passwordChars = [
    upper[Math.floor(Math.random() * upper.length)],
    lower[Math.floor(Math.random() * lower.length)],
    digits[Math.floor(Math.random() * digits.length)],
    special
  ];

  const allChars = upper + lower + digits;

  // Fill the rest with random upper/lower/digits
  for (let i = 4; i < length; i++) {
    passwordChars.push(allChars[Math.floor(Math.random() * allChars.length)]);
  }

  // Shuffle the result
  for (let i = passwordChars.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [passwordChars[i], passwordChars[j]] = [passwordChars[j], passwordChars[i]];
  }

  return passwordChars.join('');
}



        const isValidSriLankanNIC = (nic) => {
            nic = nic.trim().toUpperCase();

            // Old NIC: 9 digits + V/X (e.g., 940962706V)
            const oldNicPattern = /^(\d{9})([VX])$/;

            // New NIC: 12 digits only (e.g., 19940962706 or 199409627060)
            const newNicPattern = /^(\d{4})(\d{3})(\d{4,5})$/;

            if (oldNicPattern.test(nic)) {
                const day = parseInt(nic.slice(2, 5), 10);
                return (day >= 1 && day <= 366) || (day >= 501 && day <= 866);
            }

            if (newNicPattern.test(nic)) {
                const day = parseInt(nic.slice(4, 7), 10);
                return (day >= 1 && day <= 366) || (day >= 501 && day <= 866);
            }

            return false;
            };

            const isValidSriLankanMobile = (mobile) => {
                const pattern = /^(070|071|072|074|075|076|077|078)\d{7}$/;
                return pattern.test(mobile);
                };


    
      
    
        const validateForm = () => {
            let valid = true;
            const newErrors = {};
    
            if (!userDetailsApplyEmail.initials) {
            valid = false;
            newErrors.initials = 'Initials is required';
            }
    
           
    
            if (!userDetailsApplyEmail.lname) {
            valid = false;
            newErrors.lname = 'Last name is required';
            }

            if (!userDetailsApplyEmail.nic) {
                    valid = false;
                    newErrors.nic = 'NIC is required';
                    } else if (!isValidSriLankanNIC(userDetailsApplyEmail.nic)) {
                    valid = false;
                    newErrors.nic = 'Invalid NIC number';
                    }

            if (!userDetailsApplyEmail.mobile) {
                valid = false;
                newErrors.mobile = 'Mobile no is required';
                } else if (!isValidSriLankanMobile(userDetailsApplyEmail.mobile)) {
                valid = false;
                newErrors.mobile = 'Invalid mobile number';
                }

            if (!userDetailsApplyEmail.department) {
            valid = false;
            newErrors.department = 'Department is required';
            }

            if (!userDetailsApplyEmail.faculty) {
            valid = false;
            newErrors.faculty = 'Faculty is required';
            }

            if (!userDetailsApplyEmail.terminateDate) {
            valid = false;
            newErrors.terminateDate = 'Terminate End date is required';
            }

            if (!userDetailsApplyEmail.terminateStartDate) {
            valid = false;
            newErrors.terminateStartDate = 'Terminate start date is required';
            }

            if (!userDetailsApplyEmail.wifiKey) {
            valid = false;
            newErrors.wifiKey = 'Wi-Fi key is required';
            }
    
            setErrors(newErrors);
            return valid;
    
        };

    
        const onValueChangeApplyEmail = (event) => {
        const { name, value } = event.target;
        if(name == "faculty"){
            onChangeFacultyList(value);
        }
        handleChangeApplyEmail(name,value);
    
        // Clear error when user starts typing
        setErrors({
          ...errors,
          [name]: '',
        });
      };
    const handleChangeApplyEmail = (field, value) => {
        setUserDetailsApplyEmail(prevData => ({
          ...prevData,
          [field]: value
        }));
      };
    
// const departmentList = [
//   { id: 1, name: 'IT' },
//   { id: 2, name: 'HR' },
//   { id: 3, name: 'Finance' }
// ];

// const facultyList = [
//   { id: 1, name: "Engineering" },
//   { id: 2, name: "Science" },
//   { id: 3, name: "Business" },
// ];

 useEffect(() => {
    var tempPassword = generateWifiPassword();
        setAutogeneratedPassword(tempPassword);
        handleChangeApplyEmail("wifiKey",tempPassword)

    }, []);


    return (
        <div>
            <Dialog open={open} onClose={handleClose} maxWidth={isMobile ? 'xs' : 'sm'} fullWidth>
                <DialogTitle>Add Wi-Fi Only User</DialogTitle>
                <DialogContent>
                    <Form noValidate validated={false} onSubmit={onSubmitActionApplyEmail}>
  {/* === Name 1 & Name 2 in one row === */}
                        <Form.Group as={Row} className="mb-3">
                            <Col sm={6}>
                            <Form.Label>Initials</Form.Label>
                            <Form.Control
                                isInvalid={!!errors.initials}
                                type="text"
                                name="initials"
                                placeholder="Initials"
                                onChange={onValueChangeApplyEmail}
                            />
                            <p style={{ color: "red", fontSize: 12 }}>
                                {errors.initials}
                            </p>
                            </Col>

                            <Col sm={6}>
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                                isInvalid={!!errors.lname}
                                type="text"
                                name="lname"
                                placeholder="Last Name"
                                onChange={onValueChangeApplyEmail}
                            />
                            <p style={{ color: "red", fontSize: 12 }}>
                                {errors.lname}
                            </p>
                            </Col>
                        </Form.Group>


                        <Form.Group as={Row} className="mb-3">
                            <Col sm={6}>
                            <Form.Label>NIC</Form.Label>
                            <Form.Control
                                isInvalid={!!errors.nic}
                                type="text"
                                name="nic"
                                placeholder="NIC"
                                onChange={onValueChangeApplyEmail}
                            />
                            <p style={{ color: "red", fontSize: 12 }}>
                                {errors.nic}
                            </p>
                            </Col>

                            <Col sm={6}>
                            <Form.Label>Mobile Number</Form.Label>
                            <Form.Control
                                isInvalid={!!errors.mobile}
                                type="text"
                                name="mobile"
                                placeholder="Mobile No"
                                onChange={onValueChangeApplyEmail}
                            />
                            <p style={{ color: "red", fontSize: 12 }}>
                                {errors.mobile}
                            </p>
                            </Col>
                        </Form.Group>


                         <Form.Group as={Row} className="mb-3">
                            <Col sm={6}>
                                <Form.Label>Faculty</Form.Label>
                                <Form.Select
                                    isInvalid={!!errors.faculty}
                                    name="faculty"
                                    //value={formValues.faculty || ''}
                                    onChange={onValueChangeApplyEmail}
                                >
                                    <option value="">Select Faculty</option>
                                    {facultyList.map((faculty) => (
                                    <option key={faculty.facultyCode} value={faculty.facultyCode}>
                                        {faculty.facaltyName}
                                    </option>
                                    ))}
                                </Form.Select>
                                <p style={{ color: "red", fontSize: 12 }}>
                                    {errors.faculty}
                                </p>
                                </Col>


                                <Col sm={6}>
                                <Form.Label>Department</Form.Label>
                                <Form.Select
                                    isInvalid={!!errors.department}
                                    name="department"
                                // value={formValues.department || ''}
                                    onChange={onValueChangeApplyEmail}
                                >
                                    <option value="">Select Department</option>
                                    {departmentList.map((dept) => (
                                    <option key={dept.id} value={dept.id}>
                                        {dept.dep_name}
                                    </option>
                                    ))}
                                </Form.Select>
                                <p style={{ color: "red", fontSize: 12 }}>
                                    {errors.department}
                                </p>
                            </Col>

                        </Form.Group>


                         <Form.Group as={Row} className="mb-3">
                            <Col sm={6}>
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control
                                isInvalid={!!errors.terminateDate}
                                type="date"
                                name="terminateStartDate"
                                placeholder="Terminate Date"
                                onChange={onValueChangeApplyEmail}
                            />
                            <p style={{ color: "red", fontSize: 12 }}>
                                {errors.terminateStartDate}
                            </p>
                            </Col>

                            <Col sm={6}>
                            <Form.Label>Terminate Date</Form.Label>
                            <Form.Control
                                isInvalid={!!errors.terminateDate}
                                type="date"
                                name="terminateDate"
                                placeholder="Terminate Date"
                                onChange={onValueChangeApplyEmail}
                            />
                            <p style={{ color: "red", fontSize: 12 }}>
                                {errors.terminateDate}
                            </p>
                            </Col>
                        </Form.Group>


                        <Form.Group as={Row} className="mb-3">
                           

                            <Col sm={6}>
                            <Form.Label>Wi-Fi Password</Form.Label>
                            <Form.Control
                                isInvalid={!!errors.wifiKey}
                                type="text"
                                name="wifiKey"
                                placeholder="Wi-Fi Key"
                                value={autoGeneratedPassword}
                                onChange={onValueChangeApplyEmail}
                            />
                            <p style={{ color: "red", fontSize: 12 }}>
                                {errors.wifiKey}
                            </p>
                            </Col>
                        </Form.Group>

                       

                        {/* === Submit Button === */}
                        <Form.Group as={Row} className="mb-3">
                            <Col />
                            <Col xs="auto">
                            <Button
                                style={{ width: "180px", backgroundColor: "#990000", color: "white" }}
                                type="submit"
                            >
                                Submit
                            </Button>
                            </Col>
                        </Form.Group>
                        </Form>

                </DialogContent>
              
            </Dialog>
        </div>
    );
};

export default AddWifiUserModel;
